/**
 * Shared route paths that are referenced from more than one place.
 *
 * Only paths that are BOTH declared as a route and built into a URL elsewhere live here — a path
 * hardcoded in a single file does not need a constant. `/logout` qualifies: `AppRouter` declares it
 * and `keycloakService` builds the Keycloak post-logout `redirectUri` from it, so a change in one
 * spot would otherwise silently break logout (SonarQube: magic-string route path).
 */
export const ROUTES = {
  LOGOUT: '/logout',
};
